import ClvrComponent from '../../../../../system/vue/Core/ClvrComponent'
import { Component, Prop } from 'vue-property-decorator'
import ClvrScreenControlRowCell from '../ClvrScreenControlRowCell/ClvrScreenControlRowCell.vue'
import ClvrScreenControlHeaderCell from '../ClvrScreenControlHeaderCell/ClvrScreenControlHeaderCell.vue'
import { ClvrScreenControlCellComponentsInterface, ClvrScreenControlHeadersInterface } from '../interface'
import { CELL_COMPONENTS_MAPPING } from '../ClvrScreenControlRowCell'
import Operation from '../../../../../dPplanningOp/vue/Classes/ClvrOperation'
import { KhEllipsis } from '@internal-libraries/kheops-ui-lib'
import ScreenResolutionHelper from '../../../../../system/vue/Classes/ScreenResolutionHelper'
import { DEFAULT_ALIAS_OPTION, ScreenControlAliasOptionEnum } from '../../../enum/ScreenControlAliasOption'

@Component({
    components: {
        KhEllipsis,
        ClvrScreenControlRowCell,
        ClvrScreenControlHeaderCell,
    },
})
export default class ClvrScreenControlTable extends ClvrComponent {
    @Prop({ type: String, default: ClvrScreenControlTable.DEFAULT_TR_CSS })
    public classTr!: string
    @Prop({ type: Array, default: [] })
    public headers!: ClvrScreenControlHeadersInterface[]
    @Prop({ type: Array, default: () => [] })
    public groupOperations!: Operation[][]
    @Prop({ type: Boolean, default: false })
    public noRoomCol!: boolean
    @Prop({ type: Boolean, default: false })
    public hideData!: boolean
    @Prop({ type: String, default: DEFAULT_ALIAS_OPTION })
    public aliasOption!: string

    private readonly ROOM_FONT_SIZE_4K: number = 46
    private readonly ROOM_FONT_SIZE_FULL_HD: number = 24

    public get CELL_COMPONENTS_MAPPING(): Record<string, ClvrScreenControlCellComponentsInterface> {
        return CELL_COMPONENTS_MAPPING
    }

    public get ClvrScreenControlTable(): typeof ClvrScreenControlTable {
        return ClvrScreenControlTable
    }

    public get filteredHeaders(): ClvrScreenControlHeadersInterface[] {
        return this.headers
    }

    public static readonly TEXT_START_CELL = 'text-start'
    public static readonly ROOM_TH_CSS = 'screen-control-planning-table__room-cell'
    public static readonly ROOM_BLUE_CSS = 'screen-control-planning-table__room-cell--blue'
    public static readonly ROOM_GREEN_CSS = 'screen-control-planning-table__room-cell--green'
    // used for all cell th
    public static readonly CELL_TH_CSS = `screen-control-planning-table__cell-th ${ClvrScreenControlTable.TEXT_START_CELL} table-primary-color`
    public static readonly CELL_TH_CONTENT_CSS = `screen-control-planning-table__cell-th-content screen-control-header-cell screen-control-planning-table__primary-color`
    // used for all cell td
    public static readonly CELL_TD_CSS = `screen-control-planning-table__cell-td ${ClvrScreenControlTable.TEXT_START_CELL}`
    public static readonly CELL_TD_CONTENT_CSS = `screen-control-planning-table__cell-td-content`
    // used if the cell does not have css defined in CELL_COMPONENTS_MAPPING
    public static readonly DEFAULT_CELL_TD_CSS = `table-cell-padding screen-control-planning-table__font-feature-settings ${ClvrScreenControlTable.TEXT_START_CELL}`
    // used if the cell does not have css defined in CELL_COMPONENTS_MAPPING
    public static readonly DEFAULT_TR_CSS = 'screen-control-planning-table__cell-tr'

    public updated(): void {
        this.adjustRoomFontSize()
    }

    public getHeaderKeyName(groupIndex: number, index: number, headerIndex: number): string {
        return groupIndex + '-' + index + '-' + headerIndex
    }

    public getOperationLineClass(operation: Operation, groupIndex: number, index: number): string {
        if (operation.cancelled) {
            return 'operation_cancelled'
        }

        if (operation.emergency) {
            return 'operation_emergency'
        }

        if (0 === index % 2) {
            return 0 === groupIndex % 2 ? 'operation_blue' : 'operation_green'
        }

        return 'operation_gray'
    }

    public getRoomName(operations: Operation[]): string {
        const room = operations[0]?.room
        if (!room) return ''

        const roomName = room.name || ''
        if (this.aliasOption === ScreenControlAliasOptionEnum.ONLY_ALIAS) {
            return room.alias || roomName
        }
        if (this.aliasOption === ScreenControlAliasOptionEnum.NO_ALIAS) {
            return roomName
        }
        // Dynamic alias
        return roomName.length / 4 < operations.length ? roomName : room.alias || roomName
    }

    public adjustRoomFontSize() {
        const containers = document.querySelectorAll(
            `.${ClvrScreenControlTable.ROOM_BLUE_CSS}, .${ClvrScreenControlTable.ROOM_GREEN_CSS}`,
        )
        containers.forEach(container => {
            const contentText: string = container.textContent?.trim() || ''
            const contentLength = contentText.length
            const containerHeight = container.clientHeight
            if (contentLength) {
                const fontSize: number = Math.min(
                    containerHeight / contentLength,
                    ScreenResolutionHelper.is4KResolution() ? this.ROOM_FONT_SIZE_4K : this.ROOM_FONT_SIZE_FULL_HD,
                )
                ;(container as HTMLElement).style.fontSize = `${fontSize}px`
            }
        })
    }
}
